var ShopProfile = (function () {
    var url = "https://www.erotikastore.eu";
    var urlPath = '';
    var priceMin = 0;
    var priceMax = 0;
    var rangeLenght = 0;
    var rangeMinLenght = 0;
    var brands = [];
    var brandsID = [];
    var sizes = [];
    var sizesID = [];
    var features = [];
    var featuresID = [];
    var categoryID = 0;
    var groupID = 0;
    var navValue = 0;
    var navStep = 0;
    var navFrom = 0;
    //----> GET
    var getURLProfile = function () {
        return url;
    };
    var getUrlPathProfile = function () {
        return urlPath;
    }
    var getPriceMinProfile = function () {
        return priceMin;
    };
    var getPriceMaxProfile = function () {
        return priceMax;
    };
    var getBrandsProfile = function () {
        return brands;
    }
    var getBrandsIDProfile = function () {
        return brandsID;
    }
    var getSizesProfile = function () {
        return sizes;
    }
    var getSizesIDProfile = function () {
        return sizesID;
    }
    var getFeaturesProfile = function () {
        return features;
    }
    var getFeaturesIDProfile = function () {
        return featuresID;
    }
    var getRangeLenghtProfile = function () {
        return rangeLenght;
    }
    var getRangeMinlenghtProfile = function () {
        return rangeMinLenght;
    }
    var getCategoryIDProfile = function () {
        return categoryID;
    }
    var getGroupIDProfile = function () {
        return groupID;
    }
    var getNavValueProfile = function () {
        return navValue;
    }
    var getNavStepProfile = function () {
        return navStep;
    }
    var getNavFromProfile = function () {
        return navFrom;
    }
    //---->
    var setUrlPathProfile = function (url) {
        urlPath = url;
    }
    var setPriceMinProfile = function (min) {
        priceMin = min;
    };
    var setPriceMaxProfile = function (max) {
        priceMax = max;
    };
    var addBrandProfile = function (brand) {
        brands.push(brand);
    }
    var delBrandProfile = function (brand) {
        var pos = brands.indexOf(brand);
        brands.splice(pos, 1);
    }
    var addBrandIDProfile = function (brandID) {
        brandsID.push(brandID);
    }
    var delBrandIDProfile = function (brandID) {
        var pos = brandsID.indexOf(brandID);
        brandsID.splice(pos, 1);
    }
    var addSizeProfile = function (size) {
        sizes.push(size);
    }
    var delSizeProfile = function (size) {
        var pos = sizes.indexOf(size);
        sizes.splice(pos, 1);
    }
    var addSizeIDProfile = function (sizeID) {
        sizesID.push(sizeID);
    }
    var delSizeIDProfile = function (sizeID) {
        var pos = sizesID.indexOf(sizeID);
        sizesID.splice(pos, 1);
    }
    var addFeaturesProfile = function (feature) {
        features.push(feature);
    }
    var delFeaturesProfile = function (feature) {
        var pos = features.indexOf(feature);
        features.splice(pos, 1);
    }
    var addFeaturesIDProfile = function (featureID) {
        featuresID.push(featureID);
    }
    var delFeaturesIDProfile = function (featureID) {
        var pos = featuresID.indexOf(featureID);
        featuresID.splice(pos, 1);
    }
    var setRangeLenghtProfile = function (lenght) {
        rangeLenght = lenght;
    }
    var setRangeMinlenghtProfile = function (lenght) {
        rangeMinLenght = lenght;
    }
    var setCategoryIDProfile = function (id) {
        categoryID = id;
    }
    var setGroupIDProfile = function (id) {
        groupID = id;
    }
    var setNavValueProfile = function (value) {
        navValue = value;
    }
    var setNavStepProfile = function (step) {
        navStep = step;
    }
    var setNavFromProfile = function (from) {
        navFrom = from;
    }
    var resetFilterProfile = function () {
        priceMin = 0;
        priceMax = rangeLenght;
        brands = [];
        brandsID = [];
        sizes = [];
        sizesID = [];
        features = [];
        featuresID = [];
    }
    return {
        getURL: getURLProfile,
        getUrlPath: getUrlPathProfile,
        getPriceMin: getPriceMinProfile,
        getPriceMax: getPriceMaxProfile,
        getBrands: getBrandsProfile,
        getBrandsID: getBrandsIDProfile,
        getSizes: getSizesProfile,
        getSizesID: getSizesIDProfile,
        getFeatures: getFeaturesProfile,
        getFeaturesID: getFeaturesIDProfile,
        getRangeLenght: getRangeLenghtProfile,
        getRangeMinlenght: getRangeMinlenghtProfile,
        getCategoryID: getCategoryIDProfile,
        getGroupID: getGroupIDProfile,
        getNavValue: getNavValueProfile,
        getNavStep: getNavStepProfile,
        getNavFrom: getNavFromProfile,
        //---->
        setUrlPath: setUrlPathProfile,
        setPriceMin: setPriceMinProfile,
        setPriceMax: setPriceMaxProfile,
        addBrand: addBrandProfile,
        delBrand: delBrandProfile,
        addBrandID: addBrandIDProfile,
        delBrandID: delBrandIDProfile,
        addSize: addSizeProfile,
        delSize: delSizeProfile,
        addSizeID: addSizeIDProfile,
        delSizeID: delSizeIDProfile,
        addFeatures: addFeaturesProfile,
        delFeatures: delFeaturesProfile,
        addFeaturesID: addFeaturesIDProfile,
        delFeaturesID: delFeaturesIDProfile,
        setRangeLenght: setRangeLenghtProfile,
        setRangeMinlenght: setRangeMinlenghtProfile,
        setCategoryID: setCategoryIDProfile,
        setGroupID: setGroupIDProfile,
        setNavValue: setNavValueProfile,
        setNavStep: setNavStepProfile,
        setNavFrom: setNavFromProfile,
        //---->
        resetFilter: resetFilterProfile
    }
})();
export default ShopProfile;